// Third Party Libraries
import { get } from 'lodash'

// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'
import moment from 'moment'

import { setSelectedUser } from 'app/state/modules/team'
// user onboarding
const HACKER_POSTING_ONBOARDING = 'HACKER_POSTING_ONBOARDING'
const HACKER_POSTED_ONBOARDING = 'HACKER_POSTED_ONBOARDING'

// user profile
const HACKER_GETTING_PROFILE = 'HACKER_GETTING_PROFILE'
const HACKER_RECEIVED_PROFILE = 'HACKER_RECEIVED_PROFILE'

// updating user profile
const HACKER_UPDATING_PROFILE = 'HACKER_UPDATING_PROFILE'
const HACKER_UPDATED_PROFILE = 'HACKER_UPDATED_PROFILE'
const HACKER_UPDATED_PROFILE_ERROR = 'HACKER_UPDATED_PROFILE_ERROR'

// updating user profile
const HACKER_UPDATING_SEND_REMINDERS = 'HACKER_UPDATING_SEND_REMINDERS'
const HACKER_UPDATED_SENT_REMINDERS = 'HACKER_UPDATED_SENT_REMINDERS'
const HACKER_UPDATED_SENT_REMINDERS_ERROR = 'HACKER_UPDATED_SENT_REMINDERS_ERROR'

// check username
const HACKER_CHECKING_USERNAME = 'HACKER_CHECKING_USERNAME'
const HACKER_CHECKED_USERNAME = 'HACKER_CHECKED_USERNAME'

// code
const HACKER_POSTED_CODE = 'HACKER_POSTED_CODE'
const HACKER_UPDATED_CODE = 'HACKER_UPDATED_CODE'
const HACKER_GETTING_CODE_SUBMISSIONS = 'HACKER_GETTING_CODE_SUBMISSIONS'
const HACKER_RECEIVED_CODE_SUBMISSIONS = 'HACKER_RECEIVED_CODE_SUBMISSIONS'
const HACKER_GETTING_CODE_SUBMISSIONS_ERROR = 'HACKER_GETTING_CODE_SUBMISSIONS_ERROR'

// lrs

const LRS_SET_INFO = 'LRS_SET_INFO'

// organizations list
const HACKER_GETTING_ORGANIZATIONS = 'HACKER_GETTING_ORGANIZATIONS'
const HACKER_RECEIVED_ORGANIZATIONS = 'HACKER_RECEIVED_ORGANIZATIONS'

// team details
const HACKER_GETTING_TEAMS_DETAILS = 'HACKER_GETTING_TEAMS_DETAILS'
const HACKER_RECEIVED_TEAMS_DETAILS = 'HACKER_RECEIVED_TEAMS_DETAILS'
const HACKER_PATCHING_TEAMS_DETAILS = 'HACKER_PATCHING_TEAMS_DETAILS'
const HACKER_PATCHED_TEAMS_DETAILS = 'HACKER_PATCHED_TEAMS_DETAILS'

// team hackers
const HACKER_GETTING_TEAMS_HACKERS = 'HACKER_GETTING_TEAMS_HACKERS'
const HACKER_RECEIVED_TEAMS_HACKERS = 'HACKER_RECEIVED_TEAMS_HACKERS'
const HACKER_RECEIVED_TEAMS_HACKERS_TOTAL = 'HACKER_RECEIVED_TEAMS_HACKERS_TOTAL'
const HACKER_SET_IS_LOADING_HACKERS = 'HACKER_SET_IS_LOADING_HACKERS'
const HACKER_SET_FILTER_HACKER = 'HACKER_SET_FILTER_HACKER'
const HACKER_SET_OFFSET_HACKER = 'HACKER_SET_OFFSET_HACKER'
const HACKER_SET_ORDER_DIRECTION = 'HACKER_SET_ORDER_DIRECTION'
const HACKER_SET_ORDER = 'HACKER_SET_ORDER'

// team hacker details
const HACKER_GETTING_TEAMS_HACKERS_DETAILS = 'HACKER_GETTING_TEAMS_HACKERS_DETAILS'
const HACKER_RECEIVED_TEAMS_HACKERS_DETAILS = 'HACKER_RECEIVED_TEAMS_HACKERS_DETAILS'

// update team hacker details
const HACKER_UPDATING_TEAMS_HACKERS_DETAILS = 'HACKER_UPDATING_TEAMS_HACKERS_DETAILS'
const HACKER_UPDATED_TEAMS_HACKERS_DETAILS = 'HACKER_UPDATED_TEAMS_HACKERS_DETAILS'

// team hacker code
const HACKER_GETTING_TEAMS_HACKERS_CODE = 'HACKER_GETTING_TEAMS_HACKERS_CODE'
const HACKER_RECEIVED_TEAMS_HACKERS_CODE = 'HACKER_RECEIVED_TEAMS_HACKERS_CODE'

// team hacker add license
const HACKER_ADDING_TEAMS_HACKERS_LICENSE = 'HACKER_ADDING_TEAMS_HACKERS_LICENSE'
const HACKER_ADDED_TEAMS_HACKERS_LICENSE = 'HACKER_ADDED_TEAMS_HACKERS_LICENSE'

// team hacker remove license
const HACKER_REMOVING_TEAMS_HACKERS_LICENSE = 'HACKER_REMOVING_TEAMS_HACKERS_LICENSE'
const HACKER_REMOVED_TEAMS_HACKERS_LICENSE = 'HACKER_REMOVED_TEAMS_HACKERS_LICENSE'

// team report lessons
const HACKER_GETTING_TEAMS_REPORT_LESSONS = 'HACKER_GETTING_TEAMS_REPORT_LESSONS'
const HACKER_RECEIVED_TEAMS_REPORT_LESSONS = 'HACKER_RECEIVED_TEAMS_REPORT_LESSONS'

// team report users
const HACKER_GETTING_TEAMS_REPORT_USERS = 'HACKER_GETTING_TEAMS_REPORT_USERS'
const HACKER_RECEIVED_TEAMS_REPORT_USERS = 'HACKER_RECEIVED_TEAMS_REPORT_USERS'
const HACKER_RECEIVED_TEAMS_REPORT_USERS_ERRORS = 'HACKER_RECEIVED_TEAMS_REPORT_USERS_ERRORS'

// team certificates
const HACKER_RECEIVED_TEAM_CERTIFICATES = 'HACKER_RECEIVED_TEAM_CERTIFICATES'

// org invite admin
const HACKER_INVITING_ADMIN = 'HACKER_INVITING_ADMIN'
const HACKER_INVITED_ADMIN = 'HACKER_INVITED_ADMIN'
const HACKER_INVITED_ADMIN_ERROR = 'HACKER_INVITED_ADMIN_ERROR'

// user subscribes
const HACKER_USER_SUBSCRIBED = 'HACKER_USER_SUBSCRIBED'

// user update teams
export const UPDATE_TEAM_USER = 'UPDATE_TEAM_USER'

export const SET_IS_PICKING_PLAN = 'SET_IS_PICKING_PLAN'


const initialState = {
  // user onboarding
  loadingOnboarding: false,

  isPickingPlan: false,

  // user profile
  loadingProfile: false,
  hasLoadedProfile: false,
  profile: {
    uuid: null,
    email: null,
    username: null,
    points: 0,
    send_reminders: null,
  },
  license: null,

  // updating user profile
  updatingProfile: false,
  updatingProfileError: false,

  // updating send reminders
  updatingSendReminders: false,
  updatingSendRemindersError: false,

  // check username
  checkingUsername: false,

  // code
  latestCodePatchId: null,
  latestCodePassed: null,
  latestCodeStackTrace: null,
  currentCodeSubmissions: [],
  loadingCodeSubmissions: false,

  // organization list
  loadingOrganizations: false,
  hasLoadedOrganizations: false,
  mustPassCodingExercise: false,
  showAllTraining: true,
  organizationsList: [],
  organizationsHash: {},

  // team details
  loadingCurrentTeamDetails: false,
  hasLoadedCurrentTeamDetails: false,
  currentTeamDetails: {
    token: '',
  },
  // team hackers
  loadingCurrentTeamHackers: false,
  hasLoadedCurrentTeamHackers: false,
  currentTeamHackers: [],
  totalHackers: 0,
  totalTeams: 0,
  completedAssignedLessons: 0,
  hackersPerPage: 50,
  isLoadingHackers: true,
  offsetHackers: 0,
  orderHackersBy: 'email',
  filterHacker: '',
  orderHackersDirection: 'asc',

  // team hacker details
  loadingCurrentHackerDetails: false,
  hasLoadedCurrentHackerDetails: false,
  currentHackerDetails: {
    content_progress: {
      plan: [],
      all: [],
    },
  },

  // update team hacker details
  updatingTeamHackerDetails: false,

  // team hacker code
  loadingCurrentHackerCode: false,
  hasLoadedCurrentHackerCode: false,
  currentHackerCode: [],

  // team hacker add license
  addingTeamHackerLicense: false,

  // team hacker remove license
  removingTeamHackerLicense: false,

  // team report lessons
  loadingReportLessons: false,
  reportTotalLessons: 0,
  errorReportUsers: false,
  reportLessons: [],
  totalAssignedLessons: 0,

  // team report users
  loadingReportUsers: false,
  reportUsers: [],

  // team map
  teamMap: {},

  // org invite admin
  invitingAdmin: false,
  invitingAdminError: false,


  // team certificates
  teamCertificates: [],
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // user onboarding
    case HACKER_POSTING_ONBOARDING:
      return {
        ...state,
        loadingOnboarding: true,
      }
    case HACKER_POSTED_ONBOARDING:
      return {
        ...state,
        loadingOnboarding: false,
      }

    // user profile
    case HACKER_GETTING_PROFILE:
      return {
        ...state,
        loadingProfile: true,
      }
    case HACKER_RECEIVED_PROFILE:
      return {
        ...state,
        hasLoadedProfile: true,
        loadingProfile: false,
        profile: {
          user_id: action.uuid,
          email: action.email,
          username: action.username,
          points: action.points,
          send_reminders: action.send_reminders,
          has_finished_training: action.has_finished_training,
          last_completed_at: action.last_completed_at,
        },
        license: action.license,
      }

    // updating user profile
    case HACKER_UPDATING_PROFILE:
      return {
        ...state,
        updatingProfile: true,
        updatingProfileError: false,
      }
    case HACKER_UPDATED_PROFILE:
      return {
        ...state,
        updatingProfile: false,
        updatingProfileError: true,
        profile: {
          ...state.profile,
          username: action.username,
        },
      }
    case HACKER_UPDATED_PROFILE_ERROR:
      return {
        ...state,
        updatingProfile: false,
        updatingProfileError: true,
      }

    // updating send reminders
    case HACKER_UPDATING_SEND_REMINDERS:
      return {
        ...state,
        updatingSendReminders: true,
        updatingSendRemindersError: false,
      }
    case HACKER_UPDATED_SENT_REMINDERS:
      return {
        ...state,
        updatingSendReminders: false,
        updatingSendRemindersError: true,
        profile: {
          ...state.profile,
          send_reminders: action.send_reminders,
        },
      }
    case HACKER_UPDATED_SENT_REMINDERS_ERROR:
      return {
        ...state,
        updatingSendReminders: false,
        updatingSendRemindersError: true,
      }

    // check username
    case HACKER_CHECKING_USERNAME:
      return {
        ...state,
        checkingUsername: true,
      }
    case HACKER_CHECKED_USERNAME:
      return {
        ...state,
        checkingUsername: false,
      }

    // code
    case HACKER_POSTED_CODE:
      return {
        ...state,
        latestCodePatchId: action.latestCodePatchId,
      }
    case HACKER_UPDATED_CODE:
      return {
        ...state,
        latestCodePassed: action.latestCodePassed,
        latestCodeStackTrace: action.latestCodeStackTrace,
      }
    case HACKER_GETTING_CODE_SUBMISSIONS:
      return {
        ...state,
        loadingCodeSubmissions: true,
      }
    case HACKER_RECEIVED_CODE_SUBMISSIONS:
      return {
        ...state,
        loadingCodeSubmissions: false,
        currentCodeSubmissions: action.codeSubmissions,
      }
    case HACKER_GETTING_CODE_SUBMISSIONS_ERROR:
      return {
        ...state,
        loadingCodeSubmissions: false,
        currentCodeSubmissions: [],
      }

    // organization list
    case HACKER_GETTING_ORGANIZATIONS:
      return {
        ...state,
        loadingOrganizations: true,
      }
    case HACKER_RECEIVED_ORGANIZATIONS:
      return {
        ...state,
        hasLoadedOrganizations: true,
        loadingOrganizations: false,
        organizationsList: action.organizations,
        organizationsHash: action.organizations.reduce((prev, curr) => {
          const newPrev = { ...prev }
          newPrev[curr.uuid] = curr
          return newPrev
        }, {}),
        mustPassCodingExercise: action.mustPassCodingExercise,
        showAllTraining: action.showAllTraining,
      }

    // team details
    case HACKER_GETTING_TEAMS_DETAILS:
      return {
        ...state,
        loadingCurrentTeamDetails: true,
        hasLoadedCurrentTeamDetails: false,
      }
    case HACKER_RECEIVED_TEAMS_DETAILS:
      return {
        ...state,
        loadingCurrentTeamDetails: false,
        hasLoadedCurrentTeamDetails: true,
        currentTeamDetails: action.currentTeamDetails,
        lrs: action.currentTeamDetails.lrs,
      }
    case HACKER_PATCHING_TEAMS_DETAILS:
      return {
        ...state,
        loadingCurrentTeamDetails: true,
      }
    case HACKER_PATCHED_TEAMS_DETAILS:
      return {
        ...state,
        loadingCurrentTeamDetails: false,
        hasLoadedCurrentTeamDetails: true,
        currentTeamDetails: action.currentTeamDetails,
        mustPassCodingExercise: action.mustPassCodingExercise,
        lrs: action.currentTeamDetails.lrs,
        organizationsHash: {
          ...state.organizationsHash,
          [action.organizationId]: {
            ...state.organizationsHash[action.organizationId],
            must_pass_coding_exercise: action.mustPassCodingExercise,
          },
        },
      }

    // team hackers
    case HACKER_GETTING_TEAMS_HACKERS:
      return {
        ...state,
        loadingCurrentTeamHackers: true,
        hasLoadedCurrentTeamHackers: false,
      }
    case HACKER_RECEIVED_TEAMS_HACKERS:
      return {
        ...state,
        loadingCurrentTeamHackers: false,
        hasLoadedCurrentTeamHackers: true,
        currentTeamHackers: action.currentTeamHackers,
      }
    case HACKER_RECEIVED_TEAMS_HACKERS_TOTAL:
      return {
        ...state,
        totalHackers: action.total,
      }
    case HACKER_SET_IS_LOADING_HACKERS:
      return {
        ...state,
        isLoadingHackers: action.isLoadingHackers,
      }
    case HACKER_SET_FILTER_HACKER:
      return {
        ...state,
        filterHacker: action.filterHacker,
      }
    case HACKER_SET_OFFSET_HACKER:
      return {
        ...state,
        offsetHackers: action.offsetHackers,
      }
    case HACKER_SET_ORDER_DIRECTION:
      return {
        ...state,
        orderHackersDirection: action.orderHackersDirection,
      }
    case HACKER_SET_ORDER:
      return {
        ...state,
        orderHackersBy: action.orderHackersBy,
      }
    // team hacker certificates
    case HACKER_RECEIVED_TEAM_CERTIFICATES:
      return {
        ...state,
        teamCertificates: action.teamCertificates,
      }
    // team hacker details
    case HACKER_GETTING_TEAMS_HACKERS_DETAILS:
      return {
        ...state,
        loadingCurrentHackerDetails: true,
        hasLoadedCurrentHackerDetails: false,
      }
    case HACKER_RECEIVED_TEAMS_HACKERS_DETAILS:
      return {
        ...state,
        loadingCurrentHackerDetails: false,
        hasLoadedCurrentHackerDetails: true,
        currentHackerDetails: action.currentHackerDetails,
      }

    // update team hacker details
    case HACKER_UPDATING_TEAMS_HACKERS_DETAILS:
      return {
        ...state,
        updatingTeamHackerDetails: true,
      }
    case HACKER_UPDATED_TEAMS_HACKERS_DETAILS:
      return {
        ...state,
        updatingTeamHackerDetails: false,
      }

    // team hacker code
    case HACKER_GETTING_TEAMS_HACKERS_CODE:
      return {
        ...state,
        loadingCurrentHackerCode: true,
        hasLoadedCurrentHackerCode: false,
      }
    case HACKER_RECEIVED_TEAMS_HACKERS_CODE:
      return {
        ...state,
        loadingCurrentHackerCode: false,
        hasLoadedCurrentHackerCode: true,
        currentHackerCode: action.code,
        teamMap: {
          ...state.teamMap,
          [action.organizationUUID]: {
            ...state.teamMap[action.organizationUUID],
            users: {
              ...get(state.teamMap, `[${action.organizationUUID}]users`, {}),
              [action.hackerUUID]: {
                ...get(state.teamMap, `[${action.organizationUUID}]users[${action.hackerUUID}]`, {}),
                code: {
                  ...get(state.teamMap, `[${action.organizationUUID}]users[${action.hackerUUID}].code`, {}),
                  [action.contentUUID]: action.code,
                },
              },
            },
          },
        },
      }

    // team hacker add license
    case HACKER_ADDING_TEAMS_HACKERS_LICENSE:
      return {
        ...state,
        addingTeamHackerLicense: true,
      }
    case HACKER_ADDED_TEAMS_HACKERS_LICENSE:
      return {
        ...state,
        addingTeamHackerLicense: false,
        currentTeamDetails: {
          ...state.currentTeamDetails,
          available_licenses: state.currentTeamDetails.available_licenses - 1,
          available_license_types: state.currentTeamDetails.available_license_types.reduce((prev, curr) => {
            let currentLicenses = curr.available_licenses
            if (curr.uuid === action.licenseTypeUUID) {
              currentLicenses -= 1
            }
            if (currentLicenses > 0) {
              prev.push({
                ...curr,
                available_licenses: currentLicenses,
              })
            }
            return prev
          }, []),
        },
      }

    // team hacker remove license
    case HACKER_REMOVING_TEAMS_HACKERS_LICENSE:
      return {
        ...state,
        removingTeamHackerLicense: true,
      }
    case HACKER_REMOVED_TEAMS_HACKERS_LICENSE:
      if (state.currentTeamDetails.available_license_types.find(item => item.uuid === action.licenseTypeUUID)) {
        return {
          ...state,
          removingTeamHackerLicense: false,
          currentTeamDetails: {
            ...state.currentTeamDetails,
            available_licenses: state.currentTeamDetails.available_licenses + 1,
            available_license_types: state.currentTeamDetails.available_license_types.map((item) => {
              if (item.uuid === action.licenseTypeUUID) {
                return {
                  ...item,
                  available_licenses: item.available_licenses + 1,
                }
              }
              return item
            }),
          },
        }
      }
      return {
        ...state,
        removingTeamHackerLicense: false,
        currentTeamDetails: {
          ...state.currentTeamDetails,
          available_licenses: state.currentTeamDetails.available_licenses + 1,
          available_license_types: (() => {
            const availableLicenseTypes = [...(state.currentTeamDetails.available_license_types || [])]
            availableLicenseTypes.push({
              name: action.licenseTypeName,
              uuid: action.licenseTypeUUID,
              available_licenses: 1,
            })
            return availableLicenseTypes
          })(),
        },
      }

    // team report lessons
    case HACKER_GETTING_TEAMS_REPORT_LESSONS:
      return {
        ...state,
        loadingReportLessons: true,
      }
    case HACKER_RECEIVED_TEAMS_REPORT_LESSONS:
      return {
        ...state,
        loadingReportLessons: false,
        reportTotalLessons: action.reportTotalLessons,
        reportLessons: action.reportLessons,
        totalAssignedLessons: action.totalAssignedLessons,
        completedAssignedLessons: action.completedAssignedLessons,
        totalTimeSpent: action.totalTimeSpent,
        totalCodeSubmissions: action.totalCodeSubmissions,
        totalUsersWithPlanCompleted: action.totalUsersWithPlanCompleted,
        totalHackers: action.totalHackers,
        totalTeams: action.totalTeams,
      }
    // team report users
    case HACKER_GETTING_TEAMS_REPORT_USERS:
      return {
        ...state,
        loadingReportUsers: true,
        errorReportUsers: false,
        reportUsers: [],
      }
    case HACKER_RECEIVED_TEAMS_REPORT_USERS:
      return {
        ...state,
        loadingReportUsers: false,
        reportUsers: action.reportUsers,
      }
    case HACKER_RECEIVED_TEAMS_REPORT_USERS_ERRORS:
      return {
        ...state,
        loadingReportUsers: false,
        errorReportUsers: true,
      }

    // org invite admin
    case HACKER_INVITING_ADMIN:
      return {
        ...state,
        invitingAdmin: true,
        invitingAdminError: false,
      }
    case HACKER_INVITED_ADMIN:
      return {
        ...state,
        invitingAdmin: false,
        invitingAdminError: false,
      }
    case HACKER_INVITED_ADMIN_ERROR:
      return {
        ...state,
        invitingAdmin: false,
        invitingAdminError: true,
      }

    // user subscribes
    case HACKER_USER_SUBSCRIBED:
      return {
        ...state,
        license: true,
      }

    case UPDATE_TEAM_USER:
      return {
        ...state,
        currentTeamHackers: state.currentTeamHackers.map((hacker) => {
          if (hacker.uuid === action.hackerUUID) {
            return {
              ...hacker,
              teams: action.teams,
            }
          }
          return hacker
        }),
      }
    case SET_IS_PICKING_PLAN:
      return {
        ...state,
        isPickingPlan: action.isPickingPlan,
      }
    default:
      return state
  }
}

export function onboardUser(idToken, onboardingToken, providerName) {
  return (dispatch) => {
    dispatch({
      type: HACKER_POSTING_ONBOARDING,
    })

    let data = {}
    if (onboardingToken !== null) {
      data = { token: onboardingToken }
    } else if (providerName !== null) {
      data = { provider_name: providerName }
    }

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/onboard`,
      idToken,
      data,
    })
      .then((response) => {
        dispatch({
          type: HACKER_POSTED_ONBOARDING,
          teams: response.data,
        })
        window.localStorage.removeItem('hackedu.teams.invite_token')
        return true
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getProfile() {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_PROFILE,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/profile`,
      idToken: state.auth.user.idToken,
    }).then((response) => {
      dispatch({
        type: HACKER_RECEIVED_PROFILE,
        uuid: response.data.uuid,
        email: response.data.email,
        username: response.data.username,
        points: response.data.points,
        send_reminders: response.data.send_reminders,
        license: response.data.license,
        has_finished_training: response.data.has_finished_training,
        last_completed_at: response.data.last_completed_at,
      })
    }).catch((error) => {
      console.error(error)
    })
  }
}

export function updateUsername(username) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_UPDATING_PROFILE,
    })
    const state = getState()

    return api({
      method: 'patch',
      url: `${settings.urls.hacker}/profile`,
      idToken: state.auth.user.idToken,
      data: { username },
    })
      .then((response) => {
        if (response.success === false) {
          dispatch({
            type: HACKER_UPDATED_PROFILE_ERROR,
          })
          return false
        }
        dispatch({
          type: HACKER_UPDATED_PROFILE,
          username,
        })
        return true
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_UPDATED_PROFILE_ERROR,
        })
        return false
      })
  }
}

export function checkUsername(username) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_CHECKING_USERNAME,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/username`,
      idToken: state.auth.user.idToken,
      params: { username },
    })
      .then((response) => {
        dispatch({
          type: HACKER_CHECKED_USERNAME,
        })
        return response.data.available
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_CHECKED_USERNAME,
        })
        return false
      })
  }
}

export function updateSendReminders(sendReminders) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_UPDATING_SEND_REMINDERS,
    })
    const state = getState()

    return api({
      method: 'patch',
      url: `${settings.urls.hacker}/profile`,
      idToken: state.auth.user.idToken,
      data: {
        send_reminders: sendReminders,
      },
    })
      .then((response) => {
        if (response.success === false) {
          dispatch({
            type: HACKER_UPDATED_SENT_REMINDERS_ERROR,
          })
          return false
        }
        dispatch({
          type: HACKER_UPDATED_SENT_REMINDERS,
          send_reminders: sendReminders,
        })
        return true
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_UPDATED_SENT_REMINDERS_ERROR,
        })
        return false
      })
  }
}

export function getOrganizations() {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_ORGANIZATIONS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        let showAllTraining = false
        let mustPassCodingExercise = false

        // if the user is not in an organization, show all training
        if (response.data.length === 0) {
          showAllTraining = true
        }

        for (let team of response.data) { // eslint-disable-line
          if (team.must_pass_coding_exercise === true) {
            mustPassCodingExercise = true
          }

          // if any organization has showAllTraining on, set it to true
          if (team.show_all_training === true) {
            showAllTraining = true
          }
          if (showAllTraining && mustPassCodingExercise) {
            break
          }
        }
        dispatch({
          type: HACKER_RECEIVED_ORGANIZATIONS,
          organizations: response.data,
          mustPassCodingExercise,
          showAllTraining,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getTeamDetails(organizationId, setLrs = true) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_TEAMS_DETAILS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: HACKER_RECEIVED_TEAMS_DETAILS,
          currentTeamDetails: response.data,
        })
        if (setLrs) {
          dispatch({
            type: LRS_SET_INFO,
            ...(response.data.lrs),
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function patchTeamDetails(organizationId, params = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_PATCHING_TEAMS_DETAILS,
    })
    const state = getState()

    return api({
      method: 'patch',
      url: `${settings.urls.hacker}/organizations/${organizationId}`,
      idToken: state.auth.user.idToken,
      data: {
        must_pass_coding_exercise: params.mustPassCodingExercise,
        show_all_training: params.showAllTraining,
      },
    })
      .then((response) => {
        dispatch({
          type: HACKER_PATCHED_TEAMS_DETAILS,
          currentTeamDetails: response.data,
          mustPassCodingExercise: response.data.must_pass_coding_exercise,
          organizationId,
        })
        dispatch({
          type: LRS_SET_INFO,
          ...(response.data.lrs),
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function setFilterHacker(filterHacker) {
  return {
    type: HACKER_SET_FILTER_HACKER,
    filterHacker,
  }
}

export function setOffsetHackers(offsetHackers) {
  return {
    type: HACKER_SET_OFFSET_HACKER,
    offsetHackers,
  }
}

export function setOrderHackersDirection(orderHackersDirection) {
  return {
    type: HACKER_SET_ORDER_DIRECTION,
    orderHackersDirection,
  }
}

export function setOrderHackersBy(orderHackersBy) {
  return {
    type: HACKER_SET_ORDER,
    orderHackersBy,
  }
}

export function getAutoCompleteHackers(organizationUUID, filter) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationUUID}/hackers`,
      idToken: state.auth.user.idToken,
      params: {
        filter,
        limit: 10,
      },
    })
  }
}

export function getHackers(organizationId, disableLoader = false, hacker = false) {
  return (dispatch, getState) => {
    if (!disableLoader) {
      dispatch({
        type: HACKER_GETTING_TEAMS_HACKERS,
      })
    }
    const state = getState()
    dispatch({
      type: HACKER_SET_IS_LOADING_HACKERS,
      isLoadingHackers: true,
    })
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers`,
      idToken: state.auth.user.idToken,
      params: {
        filter: state.hacker.filterHacker,
        order: state.hacker.orderHackersBy,
        offset: state.hacker.offsetHackers,
        limit: state.hacker.hackersPerPage,
        orderDirection: state.hacker.orderHackersDirection,
      },
    })
      .then((response) => {
        dispatch({
          type: HACKER_RECEIVED_TEAMS_HACKERS,
          currentTeamHackers: response.data.users,
        })
        if (hacker) {
          dispatch(setSelectedUser(organizationId, hacker))
        }
        dispatch({
          type: HACKER_RECEIVED_TEAMS_HACKERS_TOTAL,
          total: response.data.total,
        })
        dispatch({
          type: HACKER_SET_IS_LOADING_HACKERS,
          isLoadingHackers: false,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getHackersAndExport(organizationId, callback) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers`,
      idToken: state.auth.user.idToken,
      params: {
        filter: state.hacker.filterHacker,
        order: state.hacker.orderHackersBy,
        offset: 0,
        limit: -1,
        orderDirection: state.hacker.orderHackersDirection,
      },
    })
      .then(({ data }) => {
        const headers = ['Email', 'Role', 'Teams', '% Complete']
        const rows = []
        rows.push(headers)
        data.users.forEach((row) => {
          const hackerRow = []
          hackerRow.push(row.email)
          hackerRow.push(row.role)
          let teams = ''
          if (row.teams.length > 1) {
            teams = `"${row.teams.map(({ name }) => name).join(', ')}"`
          } else {
            teams = row.teams.map(({ name }) => name).join(', ')
          }
          hackerRow.push(teams)
          hackerRow.push(`${row.progress} %`)
          rows.push(hackerRow)
        })
        const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => {
          return e.join(',')
        }).join('\n')}`
        const encodedUri = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `users_data_${moment().format('YYYY-MM-DD')}.csv`)
        document.body.appendChild(link)
        callback()
        link.click()
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getHackerDetails(organizationId, hackerId) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_TEAMS_HACKERS_DETAILS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: HACKER_RECEIVED_TEAMS_HACKERS_DETAILS,
          currentHackerDetails: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function updateHackerRole(organizationId, hackerId, role, callback = false) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_UPDATING_TEAMS_HACKERS_DETAILS,
    })
    const state = getState()

    return api({
      method: 'patch',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}`,
      idToken: state.auth.user.idToken,
      data: { role },
    })
      .then((response) => {
        dispatch({
          type: HACKER_UPDATED_TEAMS_HACKERS_DETAILS,
          currentTeamHackers: response.data,
        })
        if (typeof callback === 'function') {
          callback(state.team.currentTeam.users, hackerId)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function addLicense(organizationId, hackerId, licenseTypeUUID) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_ADDING_TEAMS_HACKERS_LICENSE,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}/license`,
      idToken: state.auth.user.idToken,
      data: {
        licenseTypeUUID,
      },
    })
      .then(() => {
        dispatch({
          type: HACKER_ADDED_TEAMS_HACKERS_LICENSE,
          licenseTypeUUID,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function removeLicense(organizationId, hackerId, licenseTypeName, licenseTypeUUID) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_REMOVING_TEAMS_HACKERS_LICENSE,
    })
    const state = getState()

    return api({
      method: 'delete',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerId}/license`,
      idToken: state.auth.user.idToken,
    })
      .then(() => {
        dispatch({
          type: HACKER_REMOVED_TEAMS_HACKERS_LICENSE,
          licenseTypeName,
          licenseTypeUUID,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getCodeSubmissions(contentId) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_CODE_SUBMISSIONS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/code`,
      idToken: state.auth.user.idToken,
      params: { content_uuid: contentId },
    })
      .then((response) => {
        dispatch({
          type: HACKER_RECEIVED_CODE_SUBMISSIONS,
          codeSubmissions: response.data.code_submissions,
        })
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_GETTING_CODE_SUBMISSIONS_ERROR,
        })
      })
  }
}

const pollCodeUntilPassed = (id, contentId, dispatch, getState) => {
  const state = getState()

  api({
    method: 'get',
    url: `${settings.urls.hacker}/code/${id}`,
    idToken: state.auth.user.idToken,
  })
    .then((response) => {
      if (response.data.passed === null) {
        setTimeout(() => {
          return pollCodeUntilPassed(id, contentId, dispatch, getState)
        }, 1000)
      } else {
        dispatch({
          type: HACKER_UPDATED_CODE,
          latestCodePassed: response.data.passed,
          latestCodeStackTrace: response.data.test.error_stack_trace,
        })
        dispatch(getCodeSubmissions(contentId))
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

export function addCode(contentId, engine, code) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/code`,
      idToken: state.auth.user.idToken,
      data: {
        content_uuid: contentId,
        engine,
        code,
      },
    })
      .then((response) => {
        pollCodeUntilPassed(response.data.id, contentId, dispatch, getState)
        dispatch({
          type: HACKER_POSTED_CODE,
          latestCodePatchId: response.data.id,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getTeamsReportLessons(organizationId, contentId) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_TEAMS_REPORT_LESSONS,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationId}/report/content?content_uuid=${contentId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        let lessonsRemaining = response.data.burnDownData.total_lessons
        const reportLessons = [{ date: '', lessons: response.data.burnDownData.total_lessons }]
        response.data.burnDownData.counts.map((day) => {
          lessonsRemaining -= day.lessons
          const d = {
            date: day.date,
            lessons: lessonsRemaining,
          }
          reportLessons.push(d)
        })

        dispatch({
          type: HACKER_RECEIVED_TEAMS_REPORT_LESSONS,
          reportTotalLessons: response.data.burnDownData.total_lessons,
          reportLessons,
          totalAssignedLessons: response.data.total_assigned_lessons,
          completedAssignedLessons: response.data.completed_assigned_lessons,
          totalTimeSpent: response.data.total_time,
          totalCodeSubmissions: response.data.total_code_submissions,
          totalUsersWithPlanCompleted: response.data.total_users_with_training_plans_completed,
          totalHackers: response.data.total_hackers,
          totalTeams: response.data.total_teams,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getCertificatesOrganization(organizationUUID, teamUUID, callback) {
  return (dispatch, getState) => {
    const state = getState()
    const url = teamUUID ? `${settings.urls.hacker}/organizations/${organizationUUID}/teams/${teamUUID}/report/certificates` : `${settings.urls.hacker}/organizations/${organizationUUID}/report/certificates`

    api({
      method: 'post',
      url,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: HACKER_RECEIVED_TEAM_CERTIFICATES,
          teamCertificates: data,
        })
        callback()
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getCSVReportUsers(organizationUUID, contentUUIDs, team, callback) {
  return (dispatch, getState) => {
    const state = getState()

    api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationUUID}/report/download`,
      idToken: state.auth.user.idToken,
      data: {
        content_uuids: contentUUIDs,
        team,
      },
    })
      .then(({ data }) => {
        const headers = data[0].content.map(content => (content.name.replace(/,/, '')))
        headers.unshift('Developer \\ Lesson')
        const rows = []
        rows.push(headers)
        data.forEach((student) => {
          const hackerRow = []
          hackerRow.push(student.email)
          student.content.forEach((content) => {
            hackerRow.push(content.completed_at || ' - ')
          })

          rows.push(hackerRow)
        })
        const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => {
          return e.join(',')
        }).join('\n')}`
        const encodedUri = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', 'HackEdu_exported_data.csv')
        document.body.appendChild(link)
        link.click()

        return callback()
      })
      .catch((error) => {
        return callback()
      })
  }
}

export function getTeamsReportUsers(organizationId, contentIds, teamId, completed) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_GETTING_TEAMS_REPORT_USERS,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationId}/report/users`,
      idToken: state.auth.user.idToken,
      data: {
        content_uuids: Array.from(contentIds),
        team_uuid: teamId,
        completed,
      },
    })
      .then((response) => {
        dispatch({
          type: HACKER_RECEIVED_TEAMS_REPORT_USERS,
          reportUsers: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_RECEIVED_TEAMS_REPORT_USERS_ERRORS,
        })
      })
  }
}

export function inviteAdmin(organizationId, email) {
  return (dispatch, getState) => {
    dispatch({
      type: HACKER_INVITING_ADMIN,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${organizationId}/admin-invite`,
      idToken: state.auth.user.idToken,
      data: { email },
    })
      .then((response) => {
        if (response.success === false) {
          dispatch({
            type: HACKER_INVITED_ADMIN_ERROR,
          })
          console.error('error inviting admin')
          return false
        }
        dispatch({
          type: HACKER_INVITED_ADMIN,
        })
        return true
      })
      .catch((error) => {
        console.error(error)
        dispatch({
          type: HACKER_INVITED_ADMIN_ERROR,
        })
      })
  }
}

export function subscribe() {
  return {
    type: HACKER_USER_SUBSCRIBED,
  }
}

export function getInviteToken() {
  return window.localStorage.getItem('hackedu.teams.invite_token')
}

export function setIsPickingPlan(isPickingPlan) {
  return {
    type: SET_IS_PICKING_PLAN,
    isPickingPlan,
  }
}

export function deleteHackerFromOrganization(organizationId, hackerUUID, callback) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'delete',
      url: `${settings.urls.hacker}/organizations/${organizationId}/hackers/${hackerUUID}`,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        if (data.success) {
          callback(false)
        } else {
          callback(true)
        }
      })
      .catch((error) => {
        console.error(error)
        callback(true)
      })
  }
}
